import React, {PureComponent} from "react"
import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"
import {greys} from "@irati/ui/src/global/colors"
import {Label2} from "@irati/ui/src/Labels"
import {onePxElevation} from "@irati/ui/src/global/elevation"

const StyledFlex = styled(Flex)`
  background-color: ${greys.white};
  border-radius: 4px;
  color: ${greys.mediumDark};
  ${onePxElevation}
`

const OnlinePin = styled(Icon)`
  stroke: ${greys.black};
  fill: none;
  margin-right: 5px;
`

interface Props {
  text: string
}

class PerksGoOnlinePill extends PureComponent<Props> {
  render() {
    const {text} = this.props

    return (
      <StyledFlex alignItems="center" padding="5px 8px">
        <OnlinePin size={12} icon="online" />
        <Label2>{text}</Label2>
      </StyledFlex>
    )
  }
}

export default PerksGoOnlinePill
